import styled from 'styled-components';
import {Button, Detail, DropdownHandler, EMPHASIS, Icon} from '@forecast-it/design-system';
import {PriorityFlag} from './PriorityBadge';
import {PRIORITY_LABELS, PRIORITY_ORDER} from '../constants/priority';

const Panel = styled.div`
	padding: ${p => p.theme.sys.spacing[200]} ${p => p.theme.sys.spacing[300]};
	min-width: 200px;
	display: flex;
	flex-direction: column;
	gap: ${p => p.theme.sys.spacing[100]};
`;
const Row = styled.div`
	display: flex;
	align-items: center;
	gap: ${p => p.theme.sys.spacing[200]};
`;
const GroupLabel = styled.div`
	${p => p.theme.sys.font?.detail?.['1']}
	color: ${p => p.theme.sys.color.text.content.auxiliary};
	margin-top: ${p => p.theme.sys.spacing[100]};
`;

/**
 * The colour-coded SLA and priority glyphs assume prior knowledge; this spells them
 * out so scanning the queue never depends on recall. Wording matches
 * `slaPresentation`, which is what the SLA column actually renders.
 */
export function SlaPriorityLegend() {
	return (
		<DropdownHandler>
			<DropdownHandler.Trigger>
				<Button emphasis={EMPHASIS.LOW} icon="info" data-cy="sla-legend-trigger">
					Legend
				</Button>
			</DropdownHandler.Trigger>
			<DropdownHandler.Content offset={4}>
				<Panel data-testid="sla-priority-legend">
					<GroupLabel>SLA</GroupLabel>
					<Row>
						<Icon icon="clock" size="s" newColor="success" />
						<Detail>On track</Detail>
					</Row>
					<Row>
						<Icon icon="warning" size="s" newColor="warning" />
						<Detail>At risk — due soon</Detail>
					</Row>
					<Row>
						<Icon icon="alert" size="s" newColor="error" />
						<Detail>Overdue</Detail>
					</Row>
					<Row>
						<Icon icon="clock" size="s" newColor="disabled" />
						<Detail>Paused</Detail>
					</Row>
					<GroupLabel>Priority</GroupLabel>
					{PRIORITY_ORDER.map(priority => (
						<Row key={priority}>
							<PriorityFlag priority={priority} />
							<Detail>{PRIORITY_LABELS[priority]}</Detail>
						</Row>
					))}
				</Panel>
			</DropdownHandler.Content>
		</DropdownHandler>
	);
}
